import { useState, useEffect } from 'react';
import { getAllTiers, ITier } from '@network/Tier';

export const useTiers = () => {
  const [tiers, setTiers] = useState<ITier[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTiers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllTiers();
      setTiers(response.tiers || []);
    } catch (err: any) {
      console.error('Error fetching tiers:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTiers();
  }, []);

  return {
    tiers,
    loading,
    error,
    refetch: fetchTiers,
  };
};
